module.exports = __webpack_public_path__ + "static/media/Jesse-Gold.6a1c2b6d.jpg";